import React from 'react';
import { Link } from 'react-router-dom';

import { NavigationBar, TabItem } from 'selfly-ui-react';

export default function NavigationView(props) {
    // const isAdmin = useCurrentUserIsAdmin();
    const permissions = props.permissions;// useCurrentUserAccessibility();
    
    const currentPath = props.location !== undefined ? (props.location.pathname === '/' ? '/alarms' : props.location.pathname) : '/alarms';

    return (
        <NavigationBar>
            <NavLink to="/alarms" current={currentPath}>
                Active Alarms
            </NavLink>
            {permissions.includes('organizationCRUD') && (
                <NavLink to="/deviceinventory" current={currentPath}>
                    Device Inventory
                </NavLink>
            )}
            {/* <NavLink to="/history" current={currentPath}>
                Alarm History
            </NavLink> */}
            <NavLink to="/devices" current={currentPath}>
                Operational Devices
            </NavLink>
            <NavLink to="/map" current={currentPath}>
                Map
            </NavLink>

            {permissions.includes('organizationCRUD') && (
                <NavLink to="/organizations" current={currentPath}>
                    Organizations
                </NavLink>
            )}

            {permissions.includes('locationCRUD') && (
                <NavLink to="/locations" current={currentPath}>
                    Locations
                </NavLink>
            )}
        </NavigationBar>
    );
}

function NavLink(props) {
    const active = props.current === props.to;

    if (active) {
        return (
            <TabItem isActive>
                <Link to={props.to}>{props.children}</Link>
            </TabItem>
        );
    }

    return (
        <TabItem>
            <Link to={props.to}>{props.children}</Link>
        </TabItem>
    );
}
